<!-- <div class="header">
  <home-header></home-header>
</div>
<div class="navigation">
  <app-home-nav></app-home-nav>
</div>
<div class="content"> -->
  <router-outlet></router-outlet>
<!-- </div>
<div class="footer">
  <home-footer></home-footer>
</div> -->
